import React, { Component } from 'react';
import CarouselSlider from '../common/CarouselSlider';
import LoginHeader from '../common/LoginHeader';
import Button from '../common/Button';
import TextInput from '../common/TextInput';
import AlertDismissable from '../common/AlertDismissable';
import CustomScroll from 'react-custom-scroll';
import { validateFormSubmit } from '../../helpers';
import { validationMessage, appBasePath, imageBasePath } from '../../constants/staticData';
import { has } from 'lodash';

export default class VerifyOTP extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submissionError: false,
      isButtonLoading: false
    };
    this.initialFormData = {
      otp: ''
    };
    this.formData = {
      ...this.initialFormData
    };
    this.errors = {
      otp: false
    };
    this.onFieldBlur = this.onFieldBlur.bind(this);
  }

  componentWillMount() {
    console.log('In the Verify OTP ....... ');
    if (this.props.params.id) {
      //const otpreq = { phone: JSON.parse(localStorage.getItem('verifyotp')).phone };
      this.props.actions.sendOtp(JSON.parse(localStorage.getItem('verifyotp')).phone );
    }
    this.props.actions.clearComponentKey();
    if (localStorage && localStorage.businessAuthData && !this.props.params.id) {
      const authData = localStorage.businessAuthData ? JSON.parse(localStorage.businessAuthData) : {};
      if (authData.phone) {
        if (authData.phoneVerified) {
          this.props.router.push(`${appBasePath}/overview`);
        }
      } else {
        this.props.router.push(`${appBasePath}/send-otp`);
      }
    } else {
      if (!this.props.params.id) {
        this.props.router.push(`${appBasePath}/`);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.authReducer.hideButtonLoader && this.state.isButtonLoading) {
      this.setState({ isButtonLoading: false });
    }
    if (nextProps.authReducer.currentComponentKey) {
      this.props.actions.clearComponentKey();
    }
    if (localStorage && localStorage.businessAuthData && !this.props.params.id) {
      const authData = localStorage.businessAuthData ? JSON.parse(localStorage.businessAuthData) : {};
      if (authData.phone) {
        if (authData.phoneVerified) {
          this.props.router.push(`${appBasePath}/overview`);
        }
      } else {
        this.props.router.push(`${appBasePath}/send-otp`);
      }
    } else {
      if (!this.props.params.id) {
        this.props.router.push(`${appBasePath}/`);
      }
    }
  }

  onFieldBlur(value, name, validateError) {
    this.formData[name] = value;
    if (has(this.errors, name)) {
      this.errors[name] = validateError;
    }
  }
  onKeyPress(e) {
    this.verifyOTPAction(e);
  }

  verifyOTPAction(e) {
    e.preventDefault();
    const authData = JSON.parse(localStorage.businessAuthData);
    const { router } = this.props;
    let formData = {
      ...this.formData
    };
    const validatedForm = validateFormSubmit(formData, this.errors);
    this.errors = validatedForm.errors;
    if (!validatedForm.validForm) {
      this.setState({ submissionError: true });
      return;
    } else {
      this.setState({ submissionError: false, isButtonLoading: true });
      if (this.props.params.id) {
        let contactUpdates = {
          name: JSON.parse(localStorage.getItem('verifyotp')).name,
          phone: JSON.parse(localStorage.getItem('verifyotp')).phone,
          otp: this.formData.otp,
          profile_photo: JSON.parse(localStorage.getItem('verifyotp')).profile_photo
        };
        this.props.actions.contactDetailsUpdate(contactUpdates, JSON.parse(localStorage.getItem('BusinessData')));
      } else {
        this.props.actions.showWelcomePage(this.formData.otp, authData.phone, authData.id);
      }
    }
  }
  componentWillUnmount() {
    this.props.actions.hideErrorMessage();
  }
  render() {
    const { router, authReducer } = this.props;
    const authData = localStorage.businessAuthData ? JSON.parse(localStorage.businessAuthData) : '';
    let sendOtp = this.props.params.id ? 'send-otp/' + this.props.params.id : 'send-otp';
    return (
      <div className="container-fluid" id="wrapper">
        <LoginHeader headerTitle="Sign Up" actions={this.props.actions} router={this.props.router} />
        <CarouselSlider pageType="signUp" altTag="Business sign up carcility" sliderImage={`${imageBasePath}/business-sign-up-carcility.png`} />
        <div className="col-md-6 col-sm-12 col-xs-12 pad0 grid-12">
          <div className="customScroll">
            <CustomScroll heightRelativeToParent="calc(100%)" allowOuterScroll={true}>
              <div className="login-panel otp">
                <div className="login-panel-header">
                  <h3 className="login-title">
                    {this.props.params.id ? 'Verify phone Number' : 'Sign up as Business'}
                  </h3>
                  {authReducer &&
                    authReducer.showErrorMessage &&
                    <AlertDismissable
                      bsStyle="danger"
                      closeLabel="Close alert"
                      closeAction={this.props.actions.hideErrorMessage}
                    >
                      <p> <i className="mdi mdi-block-helper" /> {authReducer.statusMessage} </p>
                    </AlertDismissable>}
                  <p className="note-text">
                    A One Time Password has been sent on your registered mobile number.
                    {authData &&
                      authData.phone &&
                      <strong>
                        <span className="edit-mobileno">
                          {this.props.params.id ? JSON.parse(localStorage.getItem('verifyotp')).phone : authData.phone}
                        </span>
                        <i
                          className="mdi mdi-pencil"
                          onClick={e => {
                            e.preventDefault();
                            router.push(`${appBasePath}/send-otp`);
                          }}
                        />
                      </strong>}
                  </p>
                </div>
                <div className="login-panel-body">
                  <TextInput
                    customClass="otp-input"
                    label="Enter the OTP code below to continue"
                    name="otp"
                    type="text"
                    showValidationError={this.errors['otp']}
                    validationError="Enter your OTP to continue"
                    limitCharacters={4}
                    onChange={this.onFieldBlur.bind(this)}
                    onKeyPress={this.onKeyPress.bind(this)}
                    isOTP={true}
                  />
                  <Button
                    dataLabelledby="Sign Up"
                    btnCallBack={this.verifyOTPAction.bind(this)}
                    isSubmitBtn={true}
                    btnType="red otpbtnAlign"
                    btnSize="lg"
                    fontSize={14}
                    label="Sign Up"
                    isButtonLoading={this.state.isButtonLoading}
                  />
                  <p className="note-text">
                    {"Didn't get OTP?"} <a
                      onClick={e => {
                        e.preventDefault();
                        this.props.params.id
                          ? this.props.actions.sendOtp(JSON.parse(localStorage.getItem('verifyotp')).phone)
                          : this.props.actions.resendOTP(authData.phone, true);
                      }}
                      className="blue-text"
                    >
                      {' '}Resend{' '}
                    </a>
                  </p>
                </div>
              </div>
            </CustomScroll>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Auth/VerifyOTP.jsx